import { Link } from 'react-router-dom';
import { styled, Theme } from '@mui/material';

export const sxStyles = {
  title: (theme: Theme) => ({
    marginTop: '0.75rem',
    color: theme.palette.common.black,
    wordBreak: 'break-word',
  }),
  suggest: (theme: Theme) => ({
    color: theme.palette.grey['600'],
  }),
};

export const StyledAreaOfStudyCard = styled(Link)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  minHeight: '222px',
  width: '100%',
  padding: '1.25rem',
  backgroundColor: theme.palette.common.white,
  borderRadius: '12px',
  boxShadow: `0px 8px 24px -4px ${theme.palette.divider}`,
  transition: 'color 0.5s',

  '& > svg:first-of-type': {
    fill: theme.palette.primary.main,
  },

  '&:hover': {
    h6: {
      color: theme.palette.primary.main,
    },

    boxShadow: `0px 8px 32px -4px ${theme.palette.divider}`,
  },

  [theme.breakpoints.up('sm')]: {
    maxWidth: '222px',
  },
}));

export const StyledAreaIcon = styled('i')<{ imageSrc: string }>(({ imageSrc, theme }) => ({
  display: 'flex',
  scale: '1.3',
  width: '32px',
  height: '32px',
  maskPosition: 'center',
  maskRepeat: 'no-repeat',
  maskImage: `url(${imageSrc})`,
  backgroundColor: theme.palette.primary.main,
}));
